import $ from 'jquery';

function NaviCtrl() {
	this.$win           = $(window);
	this.$body          = $('body');
	this.$header        = $('.header');
	this.$gnavi         = $('#gNavi');
	this.$gnaviBtnOpen  = this.$header.find('.btn-menu');
	this.$gnaviBtnClose = this.$gnavi.find('.btn-menu-close');
	this.$gnaviList     = this.$gnavi.find('.gnavi-list');
	this.$gnaviListLI   = this.$gnaviList.find('li');
	this.$toggleBtn     = $('.btn-toggle');
	this.$mainContent   = $('#globalContent');


	this.scrollBuffer = 0;
	this.gnaviHeight  = 0;
	this.gnaviPadding = {
		top: 0,
		bottom: 0,
	};
	this.naviPosX = 0;
	this.naviPosY = 0;

	this.open   = this.open.bind(this);
	this.close  = this.close.bind(this);
	this.screen = this.screen.bind(this);
	this.scroll = this.scroll.bind(this);
	this.console = this.console.bind(this);

	this.init();
}

NaviCtrl.prototype.init = function() {
	this.$gnaviBtnOpen.on('click.gnaviOpen', this.open);
	this.$gnaviBtnClose.on('click.gnaviClose', this.close);
}

NaviCtrl.prototype.open = function(e) {
	e.preventDefault();

	let scrollTop = this.$win.scrollTop();
	this.$gnavi.addClass('actived').addClass('navi-toggled');
	this.$body.addClass('navi-toggled');

	this.scrollBuffer = scrollTop;
	this.$mainContent.css('transform', `translateY(-${this.scrollBuffer}px)`);
	this.$gnaviListLI.css('transform', 'matrix(1, 0, 0, 1, 0, 0)');
	// this.$body.css({
	// 	height: this.screen(),
	// 	overflowX: 'hidden',
	// 	overflowY: 'auto',
	// });
	// if (this.$header.hasClass('visible')) {
	// 	this.$header.addClass('visible');
	// }

	// this.$win.on('scroll.gnaviScroll', this.scroll);
}

NaviCtrl.prototype.close = function() {
	this.$gnavi.removeClass('actived').removeClass('navi-toggled');
	this.$body.removeClass('navi-toggled');
	this.$win.scrollTop(this.scrollBuffer);
	this.$mainContent.css('transform', 'translateY(0px)');
	// this.$body.css({
	// 	height: '',
	// 	overflowX: '',
	// 	overflowY: '',
	// });

	// this.$win.off('scroll.gnaviScroll');
}

NaviCtrl.prototype.screen = function() {
	this.gnaviHeight         = parseInt(this.$gnaviList.height());
	this.gnaviPadding.top    = parseInt(this.$gnaviList.css('padding-top').replace('px', ''));
	this.gnaviPadding.bottom = parseInt(this.$gnaviList.css('padding-bottom').replace('px', ''));

	return this.gnaviHeight + this.gnaviPadding.top + this.gnaviPadding.bottom;
}

NaviCtrl.prototype.scroll = function(e) {
	e.preventDefault();

	if (this.$body.hasClass('navi-toggled') === false) return;

	this.$body.css('height', this.screen());

	let scrollTop = this.$win.scrollTop();
	let posSkewX = 2.15;
	let posX = this.$win.innerHeight() / this.$win.innerWidth();
	if (this.$win.innerWidth() < this.$win.innerHeight()) {
		posX = this.$win.innerWidth() / this.$win.innerHeight();
	}

	this.naviPosX = Math.floor(scrollTop * (posX / posSkewX));
	this.naviPosY = -(scrollTop);
	// this.$gnaviListLI.css('transform', `translate3d(${this.naviPosX}px, ${this.naviPosY}px, 0)`);
	TweenMax.to(this.$gnaviListLI, 0.5, {
		x: this.naviPosX,
		y: this.naviPosY,
	});
}

NaviCtrl.prototype.console = function () {
	const self = this;

	if (typeof $('.js-console').get(0) === 'undefined') {
		let jsConsole = $('<div/>', {
			'class': 'js-console',
			html: function () {
				$('<div/>', {
					'class': 'js-console-in',
				}).appendTo(this);
			},
		}).appendTo(this.$body);
	}

	[].forEach.call(arguments, function (log) {
		let val = '';
		console.log('NaviCtrlConsole: ' + "\n", log);
		switch (log) {
			case true:
				val = 'true';
				break;
			case false:
				val = 'false';
				break;
			case 'undefined':
				val = 'undefined';
				break;
			default:
				val = log;
				break;
		}
		$('.js-console-in').prepend(`<p>${val}</p>`);
	})
}

export default NaviCtrl;
